export default __webpack_public_path__ + "static/media/myPic.3d02f83b.jpg";